import { Avatar, Box, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from '@mui/material'
import stylesLogo from '../Accounts/Account.styles'
import sizeFontCustom from "./fontSize.styles"
import { useTranslation } from '../../hooks/useTranslation';

function FipVerifiedHeading(props) {
  const { t } = useTranslation();
  const theme = useTheme();
  const { fipId, allLinked, selectedCount, totalCount, showSelectionCount } = props;
  const secondaryTextColor =
    props.customDetails?.secondaryTextColor ?? theme.palette.text.secondary;

  return (
    <>
      <ListItem disablePadding>
        <ListItemIcon>
          <Avatar
            alt={""}
            src={global.objectFormatFip[fipId]?.productIconUri}
            sx={{ ...stylesLogo.avatarStyle, background: theme.palette.primary.light }} />
        </ListItemIcon>
        <ListItemText
          sx={{
            "& .MuiListItemText-primary": {
              color: theme.palette.info.main,
              ...sizeFontCustom.heading
            }
          }}
          primary={
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr auto",
                gap: "0.5rem",
                alignItems: "start",
                width: "100%",
              }}
            >
              <Box component="span" sx={{ minWidth: 0 }}>
                {t(`fips.${global.objectFormatFip[fipId]?.fipId}`)}
              </Box>
              {showSelectionCount && totalCount > 0 && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    height: "1lh",
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    component="span"
                    sx={{
                      fontSize: '14px',
                      lineHeight: 1,
                      color: secondaryTextColor,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {selectedCount} of {totalCount} selected
                  </Typography>
                </Box>
              )}
            </Box>
          }
        />
      </ListItem>
      {props.areAccountsDiscovered &&
        <Typography
          textAlign={"start"}
          sx={sizeFontCustom.subHeading}
          color={secondaryTextColor}
          p={"0.125rem 0 0.25rem 3rem"}
        >
          {allLinked
            ? t('accountDiscovery.messages.allAccountsLinked')
            : `${t('accountDiscovery.messages.accountsDiscovered')} ${props.phoneNumber}`}
        </Typography>}
    </>
  )
}

export default FipVerifiedHeading;
